'use strict';

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.trim");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

function g(a) {
  return a && "object" === typeof a && "default" in a ? a["default"] : a;
}

var h = g(require("babel-runtime/helpers/objectWithoutProperties")),
    l = g(require("babel-runtime/helpers/extends")),
    m = g(require("babel-runtime/core-js/object/keys")),
    n = g(require("babel-runtime/helpers/typeof")),
    r = g(require("babel-runtime/helpers/classCallCheck")),
    t = g(require("babel-runtime/helpers/createClass"));

function u(a) {
  return "function" === typeof a;
}

function v(a) {
  var b = new Intl.DateTimeFormat(a, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {});
  return function (a) {
    "string" === typeof a && (a = new Date(a));
    return b.format(a);
  };
}

function w(a) {
  var b = new Intl.NumberFormat(a, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {});
  return function (a) {
    return b.format(a);
  };
}

function x(a, b) {
  function c(a, q) {
    return function (c) {
      c = u(q) ? q(c) : q;
      c = Array.isArray(c) ? c : [c];
      var p = new Intl.NumberFormat(b).format(a);
      return c.map(function (b) {
        return "string" === typeof b ? b.replace("#", p) : b;
      });
    };
  }

  function e(b) {
    return "string" === typeof b ? f[b] || {
      style: b
    } : b;
  }

  var d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
      f = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
  b = b || a;
  var k = d.plurals;
  return {
    plural: function plural(b, a) {
      var d = a.offset;
      d = void 0 === d ? 0 : d;
      a = h(a, ["offset"]);
      a = a[b] || a[k(b - d)];
      return c(b - d, a);
    },
    selectordinal: function selectordinal(b, a) {
      var d = a.offset;
      d = void 0 === d ? 0 : d;
      a = h(a, ["offset"]);
      a = a[b] || a[k(b - d, !0)];
      return c(b - d, a);
    },
    select: function select(b, a) {
      return a[b] || a.other;
    },
    number: function number(a, d) {
      return w(b, e(d))(a);
    },
    date: function date(a, d) {
      return v(b, e(d))(a);
    },
    undefined: function undefined(b) {
      return b;
    }
  };
}

function y(a) {
  var b = a.values,
      c = x(a.language, a.locales, a.languageData, a.formats);
  return function p(a, f, k) {
    a = c[f](b[a], k);
    a = u(a) ? a(p) : a;
    return Array.isArray(a) ? a.join("") : a;
  };
}

function z(a, b, c, e) {
  return function (d) {
    var f = a(y({
      language: b,
      locales: c,
      languageData: e,
      formats: 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      values: d
    }));
    return Array.isArray(f) ? f.join("").trim() : f;
  };
}

var B = function () {
  function a() {
    r(this, a);
    this._activeMessages = {};
    this._catalogs = {};
  }

  t(a, [{
    key: "_cacheActiveLanguage",
    value: function value() {
      var a = this._catalogs[this.language],
          c = (a || {}).languageData || {};
      this._activeMessages = (a || {}).messages || {};
      this._activeLanguageData = c;
    }
  }, {
    key: "load",
    value: function value(a) {
      var b = this;
      "object" === ("undefined" === typeof a ? "undefined" : n(a)) && (m(l({}, this._catalogs, a)).forEach(function (c) {
        b._catalogs[c] = {
          messages: l({}, (b._catalogs[c] || {}).messages || {}, (a[c] || {}).messages || {}),
          languageData: l({}, (b._catalogs[c] || {}).languageData || {}, (a[c] || {}).languageData || {})
        };
      }), this._cacheActiveLanguage());
    }
  }, {
    key: "activate",
    value: function value(a, c) {
      a && (this._language = a, this._locales = c, this._cacheActiveLanguage());
    }
  }, {
    key: "use",
    value: function value(a, c) {
      return A({
        language: a,
        locales: c,
        catalogs: this._catalogs,
        development: this._dev
      });
    }
  }, {
    key: "_",
    value: function value(a) {
      var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          e = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
          d = e.defaults;
      e = e.formats;
      e = void 0 === e ? {} : e;
      a && "object" === ("undefined" === typeof a ? "undefined" : n(a)) && (b = a.values, d = a.defaults, e = a.formats, a = a.id);
      d = this.messages[a] || d || a;
      var f = this._missing;
      f && !this.messages[a] && (d = u(f) ? f(this.language, a) : f);
      return u(d) ? z(d, this.language, this.locales, this.languageData)(b, e) : d;
    }
  }, {
    key: "pluralForm",
    value: function value(a) {
      return this.languageData.plurals ? this.languageData.plurals(a, "ordinal" === (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "cardinal")) : "other";
    }
  }, {
    key: "date",
    value: function value(a, c) {
      return v(this.locales || this.language, c)(a);
    }
  }, {
    key: "number",
    value: function value(a, c) {
      return w(this.locales || this.language, c)(a);
    }
  }, {
    key: "availableLanguages",
    get: function get() {
      return m(this._catalogs);
    }
  }, {
    key: "language",
    get: function get() {
      return this._language;
    }
  }, {
    key: "locales",
    get: function get() {
      return this._locales;
    }
  }, {
    key: "messages",
    get: function get() {
      return this._activeMessages;
    }
  }, {
    key: "languageData",
    get: function get() {
      return this._activeLanguageData;
    }
  }]);
  return a;
}();

function A() {
  var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      b = new B();
  a.catalogs && b.load(a.catalogs);
  a.language && b.activate(a.language, a.locales);
  a.missing && (b._missing = a.missing);
  return b;
}

var C = A();

exports.i18nMark = function (a) {
  return a;
};

exports.i18n = C;
exports.setupI18n = A;
exports.date = v;
exports.number = w;